export default function twoDecimalPlaces(value) {
  if (!value) return;
  return value >= 100 ? value : parseFloat(Math.round(value * 100) / 100).toFixed(2);
}
